/**
 * @fileoverview Application Entry Point
 * @description Main entry file that bootstraps the React application.
 *              Auth is handled via BFF (backend session) — no OIDC provider needed.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProvider } from '@/context';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import '@/assets/styles/global.css';
import App from './App.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <AppProvider>
        <App />
      </AppProvider>
    </ErrorBoundary>
  </StrictMode>
);
